import { useEffect, useState } from "react";
import { apiGetSettings } from "../../graphQL/settings";
import { useSettingsDomain, settingsScope } from "../../graphQL/settings/scope";

// Scope comes from the active domain; the legacy authorId argument is ignored.
export const useContactStatuses = () => {
  const domain = useSettingsDomain();
  const [statuses, setStatuses] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const input = {
          schemaType: "status",
          type: "addressbook",
          ...settingsScope(domain),
        };
        const result = await apiGetSettings(input);
        const settings = Array.isArray(result?.settings) ? result.settings : [];
        const latest = settings.reduce((acc, cur) => {
          const accTs = Number(acc?.updatedAt ?? acc?.createdAt ?? 0);
          const curTs = Number(cur?.updatedAt ?? cur?.createdAt ?? 0);
          return curTs >= accTs ? cur : acc;
        }, settings[0] || null);
        const payload = latest?.data;
        const raw = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.data)
          ? payload.data
          : [];
        if (cancelled) return;
        setStatuses(
          raw.map((row, i) => ({
            ...row,
            id: row?.id || row?.value || `status_${i}`,
            isActive:
              typeof row?.isActive === "boolean"
                ? row.isActive
                : (typeof row?.style?.isActive === "boolean" ? row.style.isActive : true),
          }))
        );
      } catch (e) {
        console.error("Failed to load contact statuses:", e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [domain]);

  return statuses;
};

